// extracted by mini-css-extract-plugin
export default {"text":"ItemSet_text__6eiTN","skipButton":"ItemSet_skipButton__BI6vp","buttons":"ItemSet_buttons__L8qRR","items":"ItemSet_items__PkzDv"};